import * as React from 'react';

type FormFieldProps = React.HTMLAttributes<HTMLDivElement>;

export const FormField = ({ children, className = '', ...props }: FormFieldProps) => (
  <div className={`form-field-2024 ${className}`} {...props}>
    {children}
  </div>
);
